module.exports = "/assets/c726dcff31bb93fb8c3e7d50209ab9e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BV.png
// module id = 2373
// module chunks = 0